import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=0ef34aa4&scoped=true"
import script from "./NewAccount.vue?vue&type=script&lang=js"
export * from "./NewAccount.vue?vue&type=script&lang=js"
import style0 from "./NewAccount.vue?vue&type=style&index=0&id=0ef34aa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef34aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef34aa4')) {
      api.createRecord('0ef34aa4', component.options)
    } else {
      api.reload('0ef34aa4', component.options)
    }
    module.hot.accept("./NewAccount.vue?vue&type=template&id=0ef34aa4&scoped=true", function () {
      api.rerender('0ef34aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/NewAccount.vue"
export default component.exports